export default __webpack_public_path__ + "static/media/control-2.d3d46b5e.svg";